module.exports = __webpack_public_path__ + "static/media/housescrest.c71cb81f.png";